export default __webpack_public_path__ + "static/media/Group 82532.9ee307f7.svg";